<template>
  <button @click="openCloudinaryWidget">Upload Image</button>
  <div v-for="(url, index) in imageUrls" :key="index">
    <img :src="url" :alt="'Imagem carregada ' + index" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';




import cld from '@/cloudinary'

const imageUrls = ref([]);
let widgetLoaded = false;

onMounted(() => {
  if (!widgetLoaded) {
    const script = document.createElement('script');
    script.src = 'https://widget.cloudinary.com/v2.0/global/all.js';
    script.onload = () => widgetLoaded = true;
    document.head.appendChild(script);
  }
});

const openCloudinaryWidget = () => {
  if (!widgetLoaded) {
    alert('O widget de upload ainda está carregando. Por favor, tente novamente em alguns segundos.');
    return;
  }

  window.cloudinary.createUploadWidget(
    {
      cloudName: cld.cloudinaryConfig.cloud.cloudName,
      uploadPreset: 'img_estudantes',
      cropping: true, // Habilita o recorte
      croppingAspectRatio: 1, // Aspect ratio para o recorte, 1 para um quadrado
      // Você pode adicionar mais opções de configuração aqui
      // Mais configurações aqui se necessário
    },
    (error, result) => {
      if (!error && result && result.event === 'success') {
        console.log('Imagem carregada com sucesso: ', result.info);
        imageUrls.value.push(result.info.secure_url);
      }
    }
  ).open();
};
</script>
